import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CircularProgress from '@material-ui/core/CircularProgress';

const SelectorValueMaps = ({
  mapValue,
  stateEdit,
  totalMapsValue,
  handleSelectMapValue,
}) => (
  <div style={{ width: '100%', paddingInlineEnd: 15 }}>
    <Autocomplete
      id="categorys"
      freeSolo
      options={totalMapsValue}
      value={{
        titulo: mapValue.titulo || 'Mapa de valor no almacenado',
        y: mapValue.y || 0,
        m: mapValue.m || 0,
        d: mapValue.d || 0,
      }}
      fullWidth
      onChange={(event, mapValueSelectet) => handleSelectMapValue(mapValueSelectet)}
      getOptionLabel={(option) => `${option?.y || 0} ${option?.m || 0} ${option?.d || 0} ${
        option?.titulo || 'Mapa de valor no almacenado'
      }`}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Mapa de valor"
          variant="standard"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {totalMapsValue.length === 0 ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {!stateEdit ? (
                  <FiberManualRecordIcon style={{ color: 'green' }} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  </div>
);

export default SelectorValueMaps;
